import './App.scss';
import Home from './components/Home';
import React from "react";

function App() {
  return <Home />;
}

export default App;
